import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestMigrationPost = {
    path: "/migration/:migration/:action",
    method: RouteHttpVerb.POST
};
